import {useDispatch, useSelector} from "react-redux";
import {AppDispatch, IRootState} from "../../store/configureStore";

import React, {FC, memo, useCallback, useEffect, useMemo, useRef, useState} from "react";
import {ICameraLive, ICameraPayload, ICameraPayloadSound} from "../../store/sliceCamera";
import {CloseButton, Microfone, VideoContainer, VideoImg} from "./Style";
import {Spinner} from "react-bootstrap";
import {VolumeMute, VolumeUp, XSquareFill} from "react-bootstrap-icons";
import {actions as actionCamera} from "../../store/sliceCamera";
import {actions as modal} from "../../store/sliceModal";
import {AudioPlayer, AudioPlayerRef} from "react-audio-play";
import {getCamAudio, getCamImage} from "../../utils/selectors";

type CameraAudioProps = {
    name: string,

}




const CameraAudio: FC<CameraAudioProps> = ({name})  => {
    const dispatch = useDispatch<AppDispatch>();
    const camera: ICameraLive = useSelector((state) => getCamAudio(state, name))

    const [srcAudio, setSrcAudio] = useState<string>('');

    const [srcA, setSrcA] = useState<string>('');

    const [play, setPlay] = useState<boolean>(false);
    const [pause, setPause] = useState<boolean>(false);

    const queueRef = useRef<Array<string>>([]);
    const audioRef = useRef<AudioPlayerRef>(null);
    const [isFirstRecord, setIsFirstRecord] = useState<boolean>(false);

    // if (queueRef.current.length == 0 && !isFirstRecord) {
    //     // setSrc(new Blob([message.binaryBody.buffer]))
    //     if (camera?.audio != null && camera?.audio?.length > 0) {
    //         setSrcAudio(camera?.audio)
    //         setIsFirstRecord(true)
    //     }
    // } else {
    //     if (camera?.audio != null && srcA != camera?.audio) {
    //         setSrcA(camera?.audio)
    //         queueRef.current.push(camera?.audio)
    //         try {
    //             audioRef?.current?.play()
    //         } catch (e) {
    //
    //         }
    //     }
    // }

        if (camera?.audio != null && srcA != camera?.audio) {
            setSrcA(camera?.audio)
            queueRef.current.push(camera?.audio)
        }

        if (queueRef.current.length > 2) {
            // @ts-ignore
            setSrcAudio(queueRef.current.shift())
            if (!play) {
                audioRef?.current?.play()
            }
        }



    const audioF = useMemo(() => {
        return <div>
            {/*style={{visibility: "collapse"}}*/}
            {/*style={{visibility: "collapse",  height: 0}}*/}
            {srcAudio?.length > 100 &&
                <AudioPlayer ref={audioRef} style={{visibility: "collapse",  height: 0, width: 0}}
                    // srcAudio={`${URL.createObjectURL(src2)}`}
                             src={`data:audio/mp3;base64,${srcAudio}`}
                             onPlay={() => {
                                 setPlay(true);
                                 setPause(false);
                             }}
                             onPause={() => {
                                 setPlay(false);
                                 setPause(true);
                             }
                             }
                             autoPlay
                             volume={camera?.sound ? 100 : 0}
                             onEnd={() => {
                                 if (queueRef.current.length > 0) {
                                     // @ts-ignore
                                     // setSrc(new Blob([queueRef.current.shift()]));
                                     setSrcAudio(queueRef.current.shift());
                                 }
                             }}
                />
            }

        </div>
    }, [srcAudio, camera?.sound ])


    return (
        <div style={{width: 0}}>
            {/*style={{visibility: "collapse"}}*/}
            {/*style={{visibility: "collapse",  height: 0}}*/}
            {/*{srcAudio?.length > 100 &&*/}
            {/*    <AudioPlayer ref={audioRef}*/}
            {/*        // srcAudio={`${URL.createObjectURL(src2)}`}*/}
            {/*                 src={`data:audio/mp3;base64,${srcAudio}`}*/}
            {/*                 autoPlay*/}
            {/*                 volume={camera.sound ? 0 : 100}*/}
            {/*                 onEnd={() => {*/}
            {/*                     if (queueRef.current.length > 0) {*/}
            {/*                         // @ts-ignore*/}
            {/*                         // setSrc(new Blob([queueRef.current.shift()]));*/}
            {/*                         setSrcAudio(queueRef.current.shift());*/}
            {/*                     }*/}
            {/*                 }}*/}
            {/*    />}*/}
            {audioF}
        </div>
    )

}

export default memo(CameraAudio)
